module.exports = __webpack_public_path__ + "components/country-flag/static/cefta-50a4f48ced61cbeac98d1378113d0f6c.svg";